import SmartFeedEngine from "~/smart-feed/smart-feed-engine";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";

const COLLECTION_CONTEXT_NAME = "collection";

const EMPTY_COLLECTION_ENTITY = Object.freeze({
  collectionId: 0,
  name: "",
  description: "",
  coverImageUrl: "",
  itemCount: 0,
  visibility: "",
  status: "",
  timestampCreated: 0,
  timestampUpdated: 0,
});

// The collection a card's row was served. Until 2026-10-19 getRealEntity returned the example entity,
// so every published Collections feed listed "Demo Collection" cards.
export const CollectionCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: SmartFeedEngine.getEntityPiniaStore("collection"),
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    collectionEntityId() {
      return resolveBoundEntityId(this, COLLECTION_CONTEXT_NAME);
    },
  },
  methods: {
    getExampleEntity() {
      return {
        "collectionId": 1,
        "name": "Demo Collection",
        "description": "Demo Description",
        "coverImageUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
        "itemCount": 1,
        "visibility": "public",
        "status": "active",
        "timestampCreated": 1733412192,
        "timestampUpdated": 1733412192,
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.collectionEntityId;
      if (!id) {
        return EMPTY_COLLECTION_ENTITY;
      }
      return this.getSmartFeedEntityStore()?.entities?.[id] ?? EMPTY_COLLECTION_ENTITY;
    },
  },
};
